// dependencies
import React from "react"
import { useAuth } from "../../contexts/AuthContext"
import { signOut } from "firebase/auth"

const SignOutBtn = () => {
    const { currentUser } = useAuth()

    const handleSignOut = () => {
        signOut(currentUser.auth).catch((error) => {
            console.error("Error signing out: ", error)
        })
    }

    return currentUser ? (
        <button onClick={handleSignOut}>Sign Out</button>
    ) : null
}

export default SignOutBtn
